import "../css/billingEmail.css";
import CustomButton from "../../common_component/component/CustomButton";
import { secureAxios } from "../../_helper/constant/auth";
import { toast } from "react-toastify";
import { useState } from "react";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { getImageURLwithouttoken } from "../../_helper/utils/image";
import { useCreateItem } from "../../_helper/actions/mutation/items";

const BillingEmail = ({
  email,
  setIsSend,
  invoicePdf,
  // customerName,
  subject,
  // title,
  type,
}) => {
  const [clinic] = useAtom(clinicAtom);
  const [emailInfo, setEmailInfo] = useState({
    to: email,
    subject: subject,
  });

  const body = {
    summary: `"""
    <!DOCTYPE html>
    <html>
    <head>
        <title>Invoice Email</title>
    </head>
    <body>
        <p>Dear Sir / Madam,</p>
        <p>We are pleased to enclose the invoice copy and treatment details for your reference.</p>
        <p>If you require any further assistance or information, please feel free to contact us.</p>
        <p>Thank you for your attention to this matter.</p>
        <p>Best Regards,<br>${clinic?.clinic_name}</p>
    </body>
    </html>
    """`,

    invoice: `"""
    <!DOCTYPE html>
    <html>
    <head>
        <title>Invoice Email</title>
    </head>
    <body>
        <p>Dear Sir / Madam,</p>
        <p>We are pleased to enclose the invoice copy and treatment details for your reference.</p>
        <p>If you require any further assistance or information, please feel free to contact us.</p>
        <p>Thank you for your attention to this matter.</p>
        <p>Best Regards,<br>${clinic?.clinic_name}</p>
    </body>
    </html>
    """`,
  };

  const html = {
    summary: (
      <div style={{ maxWidth: "600px" }}>
        Dear Sir / Madam,
        <br />
        I hope this email finds you well. Attached to this message, please find
        the summary of your account's invoices.
        <br />
        This summary includes a breakdown of all the invoices issued to your
        account during the specified period, detailing the services or products
        provided, their respective amounts, and any applicable taxes or fees.
        <br /> Please review the summary carefully and let us know if you have
        any questions or concerns regarding the invoices listed.
        <br />
        Best regards,
        <br />
        {clinic?.name}
        <br />
      </div>
    ),

    invoice: (
      <div>
        Dear Sir / Madam,
        <br />
        We are pleased to enclose the invoice copy and treatment details for
        your reference.
        <br />
        If you require any further assistance or information, please feel free
        to contact us.
        <br />
        Thank you for your attention to this matter.
        <br />
        Best Regards,
        <br />
        {clinic?.name}
      </div>
    ),
  };

  const sendEmailMutation = useCreateItem("payments/billing/");

  const handleSendEmail = () => {
    const attachments = invoicePdf?.map((inc) => inc?.url);

    const payload = {
      action: "postSendMail",
      clinic_id: clinic?.id,
      frontend: "True",
      files_invoice: attachments,
      pdf_invoice: "",
      email_to_send: emailInfo?.to,
      subject: emailInfo?.subject,
      message: body[type],
      clinic_name: clinic?.clinic_name,
      for_what: type,
    };

    sendEmailMutation.mutate(payload, {
      onSuccess: () => {
        toast.success("email send successfully");
        setIsSend({ flag: false, invoicePdf: null });
      },
      onError: () => {},
    });
  };

  const handleChange = (e, label) => {
    setEmailInfo((prev) => ({ ...prev, [label]: e.target.value }));
  };

  const handleDownload = (file) => {
    const url = getImageURLwithouttoken(`${file.id}?download`);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="cu-billing-email-modal">
      <div className="cu-new-message">
        <div>New Message</div>
      </div>
      <div className="cu-sender-email-cont">
        <div>To:</div>
        <input
          type="email"
          className="cu-invoice-email-input"
          onChange={(e) => handleChange(e, "to")}
          value={emailInfo?.to}
        />
      </div>
      <div className="cu-sender-email-cont">
        <div>Subject:</div>
        <input
          type="text"
          className="cu-invoice-email-input"
          onChange={(e) => handleChange(e, "subject")}
          value={emailInfo?.subject}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <div className="cu-billing-email-body">
          <div className="cu-billing-paragraph">{html[type]}</div>
        </div>
        <div className="cu-invoice-email-attachments">
          {invoicePdf?.map((at) => {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  cursor: "pointer",
                }}
                onClick={() => handleDownload(at)}
              >
                <div>
                  <img
                    src={
                      "https://cufront-assets.s3.amazonaws.com/icons+/flat-color-icons_file.png"
                    }
                    width={"35px"}
                    height={"35px"}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: "12px" }}>{at?.fileName}</span>
                  <span style={{ fontSize: "10px" }}>Details</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="cu-billing-emial-button">
        <CustomButton
          color={"white"}
          className={"cu-invoice-button-main"}
          onClick={() => setIsSend({ flag: false, invoicePdf: null })}
        >
          Cancel
        </CustomButton>
        <CustomButton
          color={"white"}
          className={"cu-invoice-button-main"}
          onClick={handleSendEmail}
          loading={sendEmailMutation.isLoading}
        >
          Save
        </CustomButton>
      </div>
    </div>
  );
};

export default BillingEmail;
